module.exports = __webpack_public_path__ + "static/img/74-2.c01f543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/74-2.jpg
// module id = te5j
// module chunks = 0